export default __webpack_public_path__ + "src/assets/add-account.c8b6b8a8cf509c365ad7069aff780d84.svg";